<template>
    <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card>
            <v-alert class="mb-0" v-if="error" tile type="error">{{
                error
            }}</v-alert>
            <v-card-title class="primary white--text">{{
                formTitle
            }}</v-card-title>
            <v-card-text class="pt-5">
                <v-form ref="form">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="editedItem.tag"
                                :rules="[rules.required]"
                                label="Reason*"
                                outlined
                                class="subtitle-2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="pb-5 pr-5">
                <v-spacer></v-spacer>
                <v-btn text rounded @click="close">Cancel</v-btn>
                <v-btn
                    outlined
                    rounded
                    :loading="isSaving"
                    color="primary"
                    @click="save"
                    >Save</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import helper from "@/utils/helper.js";

export default {
    name: "inventory-change-reason-tag-edit-dialog",
    props: ["dialog", "object", "changeReason"],
    data() {
        return {
            error: null,
            isSaving: false,
            editedItem: {
                id: "",
                tag: ""
            },
            defaultItem: {
                id: "",
                tag: ""
            },
            rules: {
                required: v => !helper.isEmpty(v) || "This field is required",
                minLength: len => v =>
                    (v || "").length >= len ||
                    `Invalid character length, required ${len}`,
                maxLength: len => v => (v || "").length <= len || "Too long"
            }
        };
    },
    computed: {
        formTitle() {
            if (this.changeReason === "SPLIT") {
                if (this.object) {
                    return "Edit Split Reason";
                } else {
                    return "New Split Reason";
                }
            } else {
                if (this.object) {
                    return "Edit Change Reason";
                } else {
                    return "New Change Reason";
                }
            }
        }
    },
    watch: {
        // reset form when dialog open or close
        dialog() {
            this.resetForm();
        }
    },
    methods: {
        resetForm() {
            // reset form state
            this.error = null;
            this.isSaving = false;
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }

            // when editing, set form with object
            if (this.dialog && this.object) {
                this.editedItem.id = this.object.id;
                this.editedItem.changeReason = this.changeReason;
                this.editedItem.tag = this.object.tag;
            }
            // when new or closing, set form with default
            else {
                this.editedItem = Object.assign({}, this.defaultItem);
            }
        },

        close() {
            this.$emit("update:dialog", false);
            this.$emit("update:object", null);
            this.$emit("update:changeReason", null);
            this.resetForm();
        },

        save() {
            // check if form valid
            if (!this.$refs.form.validate()) {
                return;
            }

            // set form state
            this.error = null;
            this.isSaving = true;

            // prepare api call payload
            var payload = {
                changeReason: this.changeReason,
                tag: this.editedItem.tag
            };

            // edit
            if (this.object) {
                // prepare graphql mutation payload
                payload.id = this.editedItem.id;

                // if editing
                this.$store
                    .dispatch(
                        "inventoryChangeReasonTag/updateInventoryChangeReasonTag",
                        payload
                    )
                    .then(response => {
                        // update parent object
                        this.$emit("update:object", response);
                        this.close();
                    })
                    .catch(error => {
                        this.error = error.graphQLErrors[0].message;
                        this.isSaving = false;
                    })
                    .finally(() => {});
            }
            // new
            else {
                this.$store
                    .dispatch(
                        "inventoryChangeReasonTag/createInventoryChangeReasonTag",
                        payload
                    )
                    .then(response => {
                        this.$emit("item-created", response);
                        this.close();
                    })
                    .catch(error => {
                        this.error = error.graphQLErrors
                            .map(error => error.message)
                            .join(", ");
                        this.isSaving = false;
                    })
                    .finally(() => {});
            }
        }
    }
};
</script>